export default {
  group: {
    itself: 'Grup',
    plural: {
      itself: 'Grupuri',
    },
  },
};
